import { AngleUnit } from '@fulcrum/lib';
import { t } from '@trimble/i18n';
import {
  Measurement,
  AngleMeasurementType,
  MeasurementInfoButtonConfig,
} from '@trimble/web3d-providers';
import { createMemo, Show, type JSX } from 'solid-js';
import { AngleFormatter } from '@trimble/utilities';
import {
  MeasurementProperty,
  ResultRowProps,
} from '@trimble/measurements-shared';
import type { FormattingSettings } from '@trimble/types';

export interface AngleMeasurementDetailsProps {
  measurement: Measurement | undefined;
  angleUnit: AngleUnit;
  formattingSettings: FormattingSettings;
  infoButtonConfig?: MeasurementInfoButtonConfig;
}

export const AngleMeasurementDetails = (
  props: AngleMeasurementDetailsProps
): JSX.Element | null => {
  const measurementData = createMemo((): AngleMeasurementType | null => {
    if (!props.measurement) return null;
    return props.measurement as AngleMeasurementType;
  });

  const angleData = createMemo((): ResultRowProps[] | null => {
    const data = measurementData();
    if (!data) return null;

    return [
      {
        cells: [
          {
            label: t('shared.ui.unitSettings.angle'),
            value: AngleFormatter.toDisplay({
              measuredValue: data.value,
              currentUnits: props.angleUnit,
              settings: props.formattingSettings,
            }),
            testId: 'angle-value',
            valueTestId: 'angle-value-display',
          },
        ],
        testId: 'angle-values',
      },
    ];
  });

  return (
    <Show when={angleData()}>
      {(data) => (
        <div
          class="flex flex-col gap-3 p-3"
          data-testid="angle-measurement-details"
        >
          <MeasurementProperty
            icon="tc-icon-measure-angle"
            title={t('shared.ui.unitSettings.angle')}
            resultRows={data()}
            testId="angle-section"
            infoButtonConfig={props.infoButtonConfig}
          />
        </div>
      )}
    </Show>
  );
};
